import { render, staticRenderFns } from "./ajetaktarimxml.vue?vue&type=template&id=2fdc3e63&"
import script from "./ajetaktarimxml.vue?vue&type=script&lang=js&"
export * from "./ajetaktarimxml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports